import FAQManagement from "./faq-management";

export default FAQManagement;
